import styled, { css } from 'styled-components';

export const IconAvatarContainer = styled.div<{
  size: number;
  backgroundColor: string;
  borderRadius: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size, borderRadius, backgroundColor }) => css`
    min-width: ${size}px;
    max-width: ${size}px;
    min-height: ${size}px;
    max-height: ${size}px;
    border-radius: ${borderRadius}px;
    background-color: ${backgroundColor};
  `}
`;
